import { FrequencyType, TaxableIncome } from '@ndvr/portfolio-api';

import { formatDate, titleCase } from 'utils';

import { getNextFactorOccurrence } from '../../utils/factor-date-frame-utils';

export type DateStatus = 'active' | 'upcoming' | 'expired';

export const getIncomeStatus = (income: TaxableIncome): DateStatus => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = new Date(income.factorDateFrame.startDate);
    start.setHours(0, 0, 0, 0);

    if (start > today) {
        return 'upcoming';
    }

    return getNextFactorOccurrence(income.factorDateFrame, today) ? 'active' : 'expired';
};

export const getIncomeScheduleText = (income: TaxableIncome): string => {
    const { frequencyType, startDate, endDate, occurrenceCount } = income.factorDateFrame;

    if (frequencyType === FrequencyType.ONE_TIME) {
        return `One-time on ${formatDate(startDate)}`;
    }

    let scheduleText = `${titleCase(frequencyType)} starting ${formatDate(startDate)}`;

    if (occurrenceCount) {
        scheduleText += ` for ${occurrenceCount} occurrence${occurrenceCount > 1 ? 's' : ''}`;
    } else if (endDate) {
        scheduleText += ` until ${formatDate(endDate)}`;
    } else {
        scheduleText += ' until cancelled';
    }

    return scheduleText;
};
